import React from "react";
import { useVehicleModel } from "../vehicleModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";


export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useVehicleModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            // placeholder: "客户名称",
            placeholder: Locale["Customer"],
            fieldName: "customerName"
        },
        {
            type: SearchTypeEnum.Input,
            // placeholder: "车辆牌照",
            placeholder: Locale["License Plate"],
            fieldName: "licensePlate"
        },
        {
            type: SearchTypeEnum.Input,
            // placeholder: "vin码",
            placeholder: Locale["VIN"],
            fieldName: "vin"
        },
        {
            type: SearchTypeEnum.Input,
            // placeholder: "发动机号",
            placeholder: Locale["Engine No."],
            fieldName: "engineCode",
        },
        {
            type: SearchTypeEnum.Datepicker,
            // placeholder: "登记时间",
            placeholder: Locale["Record Time"],
            fieldName: "createTime",
        },
    ]
    const PageHeaderTitle = <>
        <span style={{ color: "#7F7F7F" }}>{Locale["Basic Data"]} </span>
        <span style={{ color: "#000" }}>/ {Locale["Vehicle Management"]}</span>
    </>
    return (
        <YhPageHeader
            title={PageHeaderTitle}
            triggerSearch={true}
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            handleSearch={loadData}
            handleReset={resetSearchParam}
        />
    );
}